import styled from '@emotion/styled';
import { keyframes, css } from 'emotion';

import { SIZES } from '@ezugi/constants';
import { getThemeColor, theme } from '@ezugi/ui/theme';

const { typography } = theme;

export const ENTER_TIME = 400;
export const LEAVE_TIME = ENTER_TIME;
export const Z_INDEX = 22;

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const flexCenter = css`
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  background-color: ${getThemeColor('background')};
  color: ${getThemeColor('foreground')};
  font-family: ${typography.font}, sans-serif;
  font-size: 14px;
  position: absolute;
  margin: auto;
  display: inline-flex;
  width: auto;
  ${flexCenter};
  align-content: center;
  text-align: center;
  border-radius: 8px;
  padding: 4px 60px;
  z-index: ${Z_INDEX};
  user-select: none;
  opacity: 1;
  animation: ${fadeIn} ${ENTER_TIME / 1000}s linear 1;
  transition: opacity ${LEAVE_TIME / 1000}s ${LEAVE_TIME / 1000 / 2}s linear;
  margin-top: 10px;
`;

export const StyledDescription = styled.div`
  text-align: center;
  font-weight: 500;
`;
export const notificationMobileClassName = css`
  margin-top: ${SIZES.STATUSBAR_LANDSCAPE_HEIGHT}px;
  position: fixed;
  border-radius: 0;
  opacity: 0.9;
  left: env(safe-area-inset-left);
  right: env(safe-area-inset-right);
  padding-top: 4px;

  @media all and (orientation: portrait) {
    margin-top: calc(${SIZES.STATUSBAR_PORTRAIT_HEIGHT}px + env(safe-area-inset-top));
    padding: 0;
  }
`;
